import { render, staticRenderFns } from "./YouthDemographicsLog.vue?vue&type=template&id=570f98ca"
import script from "./YouthDemographicsLog.vue?vue&type=script&lang=ts"
export * from "./YouthDemographicsLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports